module.exports = __webpack_public_path__ + "tax-icon.png?76643934206d0323125ff8359426afd6";